import { Skeleton } from "@/components/ui/skeleton";

/**
 * Generic full-page skeleton shown while a lazy route chunk is being fetched.
 * Mimics the rough structure of a typical content page (hero + grid)
 * so the layout shift when the real page mounts feels minimal.
 */
export default function RouteSkeleton() {
  return (
    <div className="container mx-auto px-4 py-16 max-w-6xl" aria-hidden="true">
      <div className="space-y-4 mb-12 text-center">
        <Skeleton className="h-6 w-40 mx-auto rounded-full" />
        <Skeleton className="h-12 w-2/3 mx-auto" />
        <Skeleton className="h-5 w-1/2 mx-auto" />
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-48 rounded-2xl" />
        ))}
      </div>
    </div>
  );
}

/** Lighter skeleton for admin pages (single panel). */
export function AdminRouteSkeleton() {
  return (
    <div className="space-y-6" aria-hidden="true">
      <div className="space-y-2">
        <Skeleton className="h-8 w-56" />
        <Skeleton className="h-4 w-80" />
      </div>
      <div className="space-y-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-16 rounded-xl" />
        ))}
      </div>
    </div>
  );
}
